/**
 * Filtres ClientSearch — default commercants + mode SA server (skipTextSearch).
 */

export function buildDefaultClientSearchFilters({ isCommercant = false, userCommercantId = null } = {}) {
  // SUPER_ADMIN / ADMIN : aucun commerçant coché par défaut.
  // COMMERCANT : pré-sélectionne sa boutique uniquement.
  const commercants =
    isCommercant && userCommercantId ? [userCommercantId] : [];

  return {
    period: 'all',
    loyaltyLevel: 'all',
    amountRange: 'all',
    status: [],
    commercants,
    activityPeriod: 'all',
    averageBasket: 'all',
    sortBy: 'dateCreation',
    sortOrder: 'desc',
  };
}

export function buildResetClientSearchFilters() {
  return {
    period: 'all',
    loyaltyLevel: 'all',
    amountRange: 'all',
    status: [],
    commercants: [],
    activityPeriod: 'all',
    averageBasket: 'all',
    sortBy: 'dateCreation',
    sortOrder: 'desc',
  };
}

/**
 * En mode SA serveur (skipTextSearch), ne pas appliquer de filtres client-side
 * sur une page partielle (merchant/loyalty/amount/activity) — ils fausseraient
 * l'affichage et le total. Passe les clients tels quels (statut géré côté API).
 */
export function shouldSkipClientSideAdvancedFilters(skipTextSearch) {
  return skipTextSearch === true;
}
